import type {FC} from 'react';
import {useState} from 'react';
import {IconButton, Stack, Tooltip, Typography} from '@wellstone-solutions/web';
import {headerPalette} from './palette';

interface GlobalIdFooterProps {
  globalId: string;
}

const truncate = (id: string) =>
  id.length > 16 ? `${id.slice(0, 8)}…${id.slice(-6)}` : id;

export const GlobalIdFooter: FC<GlobalIdFooterProps> = ({globalId}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(globalId);
    setCopied(true);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={styles.footer}>
      <Typography sx={styles.label}>Pathfinder global ID</Typography>
      <Typography sx={styles.id}>{truncate(globalId)}</Typography>
      <Tooltip title={copied ? 'Copied!' : 'Copy full ID'}>
        <IconButton
          icon="Copy"
          iconProps={{name: 'Copy', size: 15, color: headerPalette.violet}}
          size="small"
          aria-label="Copy Pathfinder global ID"
          data-testid="copy-global-id"
          onClick={handleCopy}
          onMouseLeave={() => setCopied(false)}
        />
      </Tooltip>
    </Stack>
  );
};

const styles = {
  footer: {
    borderTop: `1px solid ${headerPalette.dividerLight}`,
    marginTop: 2,
    paddingTop: '17px',
  },
  label: {
    color: headerPalette.textDisabled,
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
  id: {
    color: headerPalette.textSecondary,
    fontFamily: 'Menlo, monospace',
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
};
